module.exports = __webpack_public_path__ + "img/szjsdx.d5a38892.jpg";